import { render, staticRenderFns } from "./VenueCampaignsForApprovalList.vue?vue&type=template&id=96a5b154&"
import script from "./VenueCampaignsForApprovalList.vue?vue&type=script&lang=js&"
export * from "./VenueCampaignsForApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./VenueCampaignsForApprovalList.vue?vue&type=style&index=0&id=96a5b154&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports